import { render } from "./TrainingView.vue?vue&type=template&id=57c8e02c&scoped=true&ts=true"
import script from "./TrainingView.vue?vue&type=script&lang=ts"
export * from "./TrainingView.vue?vue&type=script&lang=ts"

import "./TrainingView.vue?vue&type=style&index=0&id=57c8e02c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c8e02c"]])

export default __exports__